// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__zKZHa","header":"MessagesList_header__T_Mr0","chat":"MessagesList_chat__OALMO"};